import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Task } from 'assets/js/classes/Task';

export default function AssigneeInitials({ assignee, className }) {
  return (
    <OverlayTrigger key={assignee.id} placement="top" overlay={<Tooltip>{assignee.username}</Tooltip>}>
      <span className={"mr-1 " + className} data-letters={Task.getAssigneeInitials(assignee.username)}></span>
    </OverlayTrigger>
  )
}